"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _multiSelectInputModule = _interopRequireDefault(require("./multiSelectInput.module.css"));

var _arrowRightIcon = _interopRequireDefault(require("../icons/arrowRightIcon"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT = 'default';
var CUSTOM = 'custom';
var NONE = 'none';
var reactSelectCustomStyles = {
  control: function control(provided, state) {
    return _objectSpread({}, provided, {
      border: '1px solid #d8d8d8',
      borderRadius: '0px',
      boxShadow: '0 1px 3px #d8d8d8 inset',
      '&:hover': {
        border: '1px solid #d8d8d8'
      },
      minHeight: 36,
      backgroundColor: state.isDisabled ? 'rgba(176,176,176,0.1)' : 'inherit',
      pointerEvents: state.isDisabled ? 'auto' : 'default',
      cursor: state.isDisabled ? 'not-allowed' : 'default'
    });
  },
  container: function container(base) {
    return _objectSpread({}, base, {
      minHeight: 34
    });
  },
  placeholder: function placeholder(base, state) {
    return _objectSpread({}, base, {
      fontWeight: 'normal',
      color: state.isDisabled ? 'rgba(169,169,169,1)' : '#000',
      fontFamily: "Arial, sans-serif",
      fontSize: "15px"
    });
  },
  loadingIndicator: function loadingIndicator(base) {
    return _objectSpread({}, base, {
      marginRight: '18px'
    });
  },
  dropdownIndicator: function dropdownIndicator(base) {
    return _objectSpread({}, base);
  },
  clearIndicator: function clearIndicator(base, state) {
    return _objectSpread({}, base, {
      display: state.selectProps.hideClearIndicator ? "none" : "flex",
      paddingTop: 0,
      paddingBottom: 0,
      color: "#000",
      marginRight: '28px',
      position: "absolute",
      top: 8,
      right: 0
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return _objectSpread({}, base, {
      display: 'flex',
      alignItems: "center"
    });
  },
  indicatorSeparator: function indicatorSeparator(base) {
    return {
      display: 'none'
    };
  },
  input: function input(base) {
    return _objectSpread({}, base, {
      margin: 0,
      padding: 0,
      fontFamily: 'arial, sans-serif',
      color: 'black'
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread({}, provided, {
      zIndex: 3
    });
  },
  option: function option(base, state) {
    return _objectSpread({}, base, {
      fontFamily: 'arial, sans-serif',
      color: 'black',
      opacity: state.isDisabled ? 0.5 : 1,
      cursor: state.isDisabled ? 'not-allowed' : null,
      fontSize: '1em; color: #000'
    });
  },
  multiValueRemove: function multiValueRemove(base, state) {
    return _objectSpread({}, base, {
      display: state.isDisabled ? 'none' : 'inherit'
    });
  },
  multiValueLabel: function multiValueLabel(base, state) {
    return _objectSpread({}, base, {
      maxWidth: state.selectProps.controlChipLabelWidth,
      textOverflow: state.selectProps.controlChipLabelWidth != "100%" ? 'ellipsis' : 'clip'
    });
  }
};

var DropdownIndicator = function DropdownIndicator(props) {
  if (props.selectProps.dropdownIndicatorType === NONE) {
    return null;
  }

  if (props.selectProps.dropdownIndicatorType === DEFAULT) {
    return _react.default.createElement(_reactSelect.components.DropdownIndicator, props, _react.default.createElement("button", {
      className: (0, _classnames.default)(_multiSelectInputModule.default["btn"], _multiSelectInputModule.default["form-control"], _multiSelectInputModule.default["buttonPicker"]),
      tabIndex: -1
    }, _react.default.createElement(_arrowRightIcon.default, {
      className: _multiSelectInputModule.default["icon-arrow"]
    })));
  }

  if (props.selectProps.dropdownIndicatorType === CUSTOM) {
    return _react.default.createElement(_reactSelect.components.DropdownIndicator, props, props.selectProps.dropdownIndicatorIcon);
  }

  return null;
};

var CustomMultiValue = function CustomMultiValue(props) {
  // Access the selected option's label and value to create the data-test-id
  var data = props.data;
  var testId = "multi-value";
  return _react.default.createElement("div", {
    "data-testid": testId
  }, _react.default.createElement(_reactSelect.components.MultiValue, props));
};

var CustomMultiValueLabel = function CustomMultiValueLabel(props) {
  // Generate a test id for the clear button based on the value
  var testId = "multi-value-label";
  return _react.default.createElement("div", {
    "data-testid": testId
  }, _react.default.createElement(_reactSelect.components.MultiValueLabel, props));
};

var CustomMultiValueRemove = function CustomMultiValueRemove(props) {
  // Generate a test id for the clear button based on the value
  var testId = "multi-value-remove-button";
  return _react.default.createElement("div", {
    "data-testid": testId
  }, _react.default.createElement(_reactSelect.components.MultiValueRemove, props));
};

var CustomClearIndicator = function CustomClearIndicator(props) {
  // Generate a test id for the clear button based on the value
  var testId = "clear-button";
  return _react.default.createElement("div", {
    "data-testid": testId
  }, _react.default.createElement(_reactSelect.components.ClearIndicator, props));
};

var CustomMenuList = function CustomMenuList(props) {
  // Generate a test id for the clear button based on the value
  var dropdownTestId = "multi-value-options";
  return _react.default.createElement("div", {
    "data-testid": dropdownTestId
  }, _react.default.createElement(_reactSelect.components.MenuList, props));
};

var CustomSelectOption = function CustomSelectOption(props) {
  // Generate a test id for the clear button based on the value
  var testId = "multi-value-option";
  return _react.default.createElement("div", {
    "data-testid": testId
  }, _react.default.createElement(_reactSelect.components.Option, props));
};

var valueFromIds = function valueFromIds(opts, values) {
  return values.map(function (value) {
    return opts.find(function (o) {
      return o.value === value.value;
    });
  });
};

var formatGroupLabel = function formatGroupLabel(data) {
  return _react.default.createElement("option", {
    disabled: true,
    className: _multiSelectInputModule.default['option-group']
  }, "".concat(data.label, "  (").concat(data.options.length, ")"));
};

var MultiSelectInput = function MultiSelectInput(props) {
  var options = props.options,
      onChange = props.onChange,
      value = props.value,
      isLoading = props.isLoading,
      instanceId = props.instanceId,
      isDisabled = props.isDisabled,
      onBlur = props.onBlur,
      autoComplete = props.autoComplete,
      openMenuOnClick = props.openMenuOnClick,
      isSearchable = props.isSearchable,
      dropdownIndicatorIcon = props.dropdownIndicatorIcon,
      dropdownIndicatorType = props.dropdownIndicatorType,
      controlChipLabelWidth = props.controlChipLabelWidth,
      hideClearIndicator = props.hideClearIndicator,
      placeholder = props.placeholder,
      isOptionDisabled = props.isOptionDisabled; //get the label that corresponds to the selected value ids of the option items

  var mappedValue = value;

  try {
    var optionsOfMultiselect = options;

    if (options.some(function (obj) {
      return obj.hasOwnProperty('options');
    })) {
      optionsOfMultiselect = options.flatMap(function (obj) {
        return obj.options;
      });
    }

    mappedValue = valueFromIds(optionsOfMultiselect, value);
  } catch (e) {
    mappedValue = [];
  }

  return _react.default.createElement(_reactSelect.default, {
    formatGroupLabel: formatGroupLabel,
    instanceId: instanceId,
    inputProps: {
      autoComplete: autoComplete ? autoComplete : ""
    },
    components: {
      DropdownIndicator: DropdownIndicator,
      MultiValue: CustomMultiValue,
      MultiValueLabel: CustomMultiValueLabel,
      MultiValueRemove: CustomMultiValueRemove,
      ClearIndicator: CustomClearIndicator,
      MenuList: CustomMenuList,
      Option: CustomSelectOption
    },
    isMulti: true,
    styles: reactSelectCustomStyles,
    onChange: onChange,
    options: options,
    value: mappedValue,
    placeholder: placeholder,
    isLoading: isLoading,
    isDisabled: isDisabled,
    controlChipLabelWidth: controlChipLabelWidth,
    onBlur: onBlur,
    openMenuOnClick: openMenuOnClick,
    isSearchable: isSearchable,
    dropdownIndicatorIcon: dropdownIndicatorIcon,
    dropdownIndicatorType: dropdownIndicatorType,
    hideClearIndicator: hideClearIndicator,
    isOptionDisabled: isOptionDisabled
  });
};

MultiSelectInput.defaultProps = {
  dropdownIndicatorType: DEFAULT,
  controlChipLabelWidth: "100%",
  hideClearIndicator: false,
  placeholder: "Select..."
};
MultiSelectInput.propTypes = {
  /** An array with the options as objects. Every object - option must contain a value and label property.
   * {value: 4, label: "First item"}. You can also choose to pass any other property to the option object you want */
  options: _propTypes.default.array.isRequired,

  /** Callback invoked when the selected items change. It will be passed the new selectedItems as the first argument
   * eg: (values) => {} */
  onChange: _propTypes.default.func.isRequired,

  /** String text that enables or disable the browser to offer autocompletion */
  autoComplete: _propTypes.default.string,

  /** An array that must contain all the selected options with their value properties (they are used as keys) */
  value: _propTypes.default.array.isRequired,

  /** Boolean indicating if the multi select is loading the options */
  isLoading: _propTypes.default.bool,

  /** String that can be anything unique */
  instanceId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,

  /** Boolean indicating if the input is disabled or not */
  isDisabled: _propTypes.default.bool,

  /** Boolean indicating if the option dropdown opens on click */
  openMenuOnClick: _propTypes.default.bool,

  /** Boolean indicating if typing in the input is enabled (different than isDisabled) **/
  isSearchable: _propTypes.default.bool,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} **/
  onBlur: _propTypes.default.func,

  /** Dropdown Icon is a jsx component element  **/
  dropdownIndicatroIcon: _propTypes.default.element,

  /** DropdownIndicatorType **/
  dropdownIndicatorType: _propTypes.default.oneOf(DEFAULT, NONE, CUSTOM),

  /** Define the chip label max width. If exceeded text-overflow= ellipsis will be applied **/
  controlChipLabelWidth: _propTypes.default.string,

  /** Hide the X for clearing all selected options **/
  hideClearIndicator: _propTypes.default.bool,

  /** Placeholder text when nothing is selected **/
  placeholder: _propTypes.default.string,

  /** isOptionDisabled Override the built-in logic to detect whether an option is disabled **/
  isOptionDisabled: _propTypes.default.string
};
var _default = MultiSelectInput;
exports.default = _default;